export default __webpack_public_path__ + "static/media/loading.4334c9cc.gif";